import { isEnterPressed } from "../lib/utils";

const $INPUTS = $(".js-input");

const clearAllFormInputs = () => {
  $INPUTS.val("");
};

export const inputFunctions = () => {
  $.each($INPUTS, function (_, el) {
    const $input = $(el);
    const $inputBox = $(el).parent(".js-input-box");
    const $searchBtn = $inputBox.find(".js-input-search-btn:first");
    const $eraseBtn = $inputBox.find(".js-input-erase-btn:first");

    const toggleShowEraseBtn = () => {
      $input.on("input", function () {
        if ($input.val().trim() !== "") {
          $eraseBtn.show();
        } else {
          $eraseBtn.hide();
        }
      });
    };

    const writeQueryParamToUrl = () => {
      if (
        $input.val().trim() !== "" &&
        !$input.parents(".press-center").length
      ) {
        if (window.location.hostname === "localhost") {
          window.location.href = `http://localhost:3004/search.html?q=${$input.val()}`;
        } else {
          window.location.href = `${
            window.location.origin
          }/search/?q=${$input.val()}`;
        }
      }
    };

    const goToSearchPage = () => {
      if (
        !$input.hasClass("js-input-press") &&
        !$inputBox.hasClass("buy-form__input-box")
      ) {
        $searchBtn.on("click", function () {
          writeQueryParamToUrl();
        });

        $input.on("keydown", function (event) {
          if (isEnterPressed(event)) {
            writeQueryParamToUrl();
          }
        });

        if ($input.hasClass("js-search-page-input")) {
          $($input.parents(".js-search-page-search-panel:first"))
            .find(".js-search-page-search-btn")
            .on("click", function () {
              writeQueryParamToUrl();
            });
        }
      }
    };

    const eraseInputValByBtn = () => {
      $eraseBtn.on("click", function () {
        $input.val("").focus();
        $eraseBtn.hide();
      });
    };

    const showEraseBtnOnFocusInput = () => {
      $input.on("focus", function () {
        if ($input.val().trim() !== "") {
          $eraseBtn.show();
        }
      });
    };

    goToSearchPage();
    toggleShowEraseBtn();
    eraseInputValByBtn();
    showEraseBtnOnFocusInput();
  });

  // clearAllFormInputs();
};
